import { Filter } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { HubertBadge } from 'components/HubertUI/HubertBadge';
import { HubertButton } from 'components/HubertUI/HubertButton';
import HubertPopover from 'components/HubertUI/HubertPopover';

type Props = {
  /** How many of the filters inside are set, so they aren't forgotten while the popover is closed. */
  activeCount: number;
  children: ReactNode;
};

const FiltersPopover = ({ activeCount, children }: Props) => {
  const { t } = useTranslation('common');
  return (
    <HubertPopover>
      <HubertPopover.Trigger asChild>
        <HubertButton size={'sm'} variant={'outline'} iconLeft={<Filter />} contentClassName="flex items-center">
          {t('filters.label')}
          {activeCount > 0 && (
            <HubertBadge variant={'secondary'} className="ml-1 px-1.5 py-0">
              {activeCount}
            </HubertBadge>
          )}
        </HubertButton>
      </HubertPopover.Trigger>
      {/* Room on the right for the close button, which sits in the corner. */}
      <HubertPopover.Content className="py-4 pr-8 pl-4">{children}</HubertPopover.Content>
    </HubertPopover>
  );
};

export default FiltersPopover;
